import {
    EditOutlined,
    ExclamationCircleFilled,
    FileTextOutlined,
} from "@ant-design/icons";
import { Card, Col, Modal, Row, Space, Tabs, Tag } from "antd";
import React, { createRef, useEffect, useMemo, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import { toast } from "react-toastify";
import Footer from "../../../components/Footer";
import NavBar from "../../../components/NavBar";
import SideBar from "../../../components/SideBar";
import { rightsService } from "../../../services/rightsService";
import axiosInstance from "../../../variables/api/axiosInstance";
import { API_URL, TOKEN } from "../../../variables/constants";
import { PDFDocument } from "pdf-lib";
import html2canvas from "html2canvas";
import axiosMultiPartDataInstance from "../../../variables/api/axiosMultiPartDatainstance";
import AvenantsTab from "./details/AvenantTab";
import DetailsTab from "./details/DetailsTab";
const { confirm } = Modal;

const { TabPane } = Tabs;

const DetailsContrat = () => {
    const [contrat, setContrat] = useState();
    const [activeTab, setActiveTab] = useState("details");
    const [tabId, setTabId] = useState("1");
    const [regle, setRegle] = useState(false);
    const [reglements, setReglements] = useState([]);
    const [reglement, setReglement] = useState();
    const [modalOpen, setModalOpen] = useState(false);
    const [modalAttOpen, setModalAttOpen] = useState(false);
    const [modalCEDEAOAttOpen, setModalCEDEAOAttOpen] = useState(false);
    const [printingCP, setPrintingCP] = useState(false);
    const [printingAttestation, setPrintingAttestation] = useState(false);
    const [printingCEDEAOAttestation, setPrintingCEDEAOAttestation] = useState(false);
    const [modalModePaiement, setModalModePaiement] = useState(false);
    const [banques, setBanques] = useState([]);
    const [pdfPreviewUrl, setPdfPreviewUrl] = useState("");
    const [numeroAttestation, setNumeroAttestation] = useState("");
    const [modalIncorporation, setModalIncorporation] = useState(false);
    const [modalRetrait, setModalRetrait] = useState(false);
    const [modalAugmentation, setModalAugmentation] = useState(false);
    const [modalDiminution, setModalDiminution] = useState(false);
    const [modalProrogation, setModalProrogation] = useState(false);
    const [modalRemiseEnVigueur, setModalRemiseEnVigueur] = useState(false);
    const [modalSuspension, setModalSuspension] = useState(false);
    const [modalReportEffet, setModalReportEffet] = useState(false);
    const [modalTransfertGarantie, setModalTransfertGarantie] = useState(false);
    const [modalChangementVehicule, setModalChangementVehicule] = useState(false);
    const [modalRenouvellement, setModalRenouvellement] = useState(false);
    const [havingRistourne, setHavingRistourne] = useState(false);
    const [attestationDamaged, setAttestationDamaged] = useState(false);
    const [layout, setLayout] = useState("portrait"); // Default layout
    const [loadingPrinting, setLoadingPrinting] = useState(false);
    const [contratModal, setContratModal] = useState(false);
    const [loading, setLoading] = useState(true);
    const [reload, setReload] = useState(false);
    const [modalAvenantOrdre, setModalAvenantOrdre] = useState(false);
    const [modalAvenantOrdreEngin, setModalAvenantOrdreEngin] = useState(false);
    const [modalDuplicata, setModalDuplicata] = useState(false);
    const [modalResiliation, setModalResiliation] = useState(false);
    const [preview, setPreview] = useState({});
    const [hasCEDEAOGarantie, setHasCEDEAOGarantie] = useState(false);

    const param = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        axiosInstance.get(`/api/contrat/preview/${param?.contratId}`).then((res) => {
            console.log("PREVIEW: ", res.data);
            setPreview(res.data);
        }).catch((err) => {
            console.log(err);
        });
    }, [param?.contratId]);

    useEffect(() => {

        const cedeao = () => {
            console.log("Contrat CEDEAO", contrat);
            if (!Array.isArray(contrat?.engins)) {
                return false;
            }
            console.log("Contrat CEDEAO", contrat);
            return preview?.engins?.some((engin) => {
                const garantiesCandidates = [
                    ...(Array.isArray(engin?.compulsoryGuaranties) ? engin.compulsoryGuaranties : []),
                    ...(Array.isArray(engin?.sousGaranties) ? engin.sousGaranties : []),
                    ...(Array.isArray(engin?.garanties) ? engin.garanties : []),
                ];

                return garantiesCandidates?.some((garantie) => {
                    const label = `${garantie?.nom ?? ""} ${garantie?.code ?? ""}`.toUpperCase();
                    console.log("Label", label);
                    console.log("Label oui? ", label.includes("CEDEAO"));
                    return label.includes("CEDEAO");
                });
            });
        }
        const data = cedeao();
        setHasCEDEAOGarantie(data);

    }, [contrat, preview]);

    // const hasCEDEAOGarantie = useMemo(() => {
    //     if (!Array.isArray(contrat?.engins)) {
    //         return false;
    //     }
    //     console.log("Contrat CEDEAO", contrat);
    //     return contrat.engins.some((engin) => {
    //         const garantiesCandidates = [
    //             ...(Array.isArray(engin?.compulsoryGuaranties) ? engin.compulsoryGuaranties : []),
    //             ...(Array.isArray(engin?.sousGaranties) ? engin.sousGaranties : []),
    //             ...(Array.isArray(engin?.garanties) ? engin.garanties : []),
    //         ];

    //         return garantiesCandidates.some((garantie) => {
    //             const label = `${garantie?.nom ?? ""} ${garantie?.code ?? ""}`.toUpperCase();
    //             console.log("Label", label);
    //             return label.includes("CEDEAO");
    //         });
    //     });
    // }, [contrat]);

    const handleTabChange = (tab) => {
        setActiveTab(tab);
    };

    const getStatusColor = (statut) => {
        const colors = {
            'VALIDE': '#10b981',
            'EN_PROPOSITION': '#f59e0b',
            'SUSPENDU': '#ef4444',
            'RESILIE': '#6b7280'
        };
        return colors[statut] || '#6b7280';
    };

    const getStatusText = (statut) => {
        const texts = {
            'VALIDE': 'Validé',
            'EN_PROPOSITION': 'En proposition',
            'SUSPENDU': 'Suspendu',
            'RESILIE': 'Résilié'
        };
        return texts[statut] || statut;
    };

    useEffect(() => {
        // Remove any previously injected styles
        document.querySelectorAll("link[data-print-style]").forEach((el) => el.remove());

        // Create a new link element for the selected CSS
        const link = document.createElement("link");
        link.rel = "stylesheet";
        link.type = "text/css";
        link.href = layout === "portrait" ? "/portrait.css" : "/landscape.css";
        link.setAttribute("data-print-style", "true");

        document.head.appendChild(link);
    }, [layout]);

    const onTabsChange = (key) => {
        // console.log(key);
        if (key === "3") {
            setModalAttOpen(true);
        }

        if (key === "5" && hasCEDEAOGarantie) {
            setModalCEDEAOAttOpen(true);
        }
        setTabId(key);
    };

    useEffect(() => {
        if (!hasCEDEAOGarantie) {
            setModalCEDEAOAttOpen(false);
            if (tabId === "5") {
                setTabId("1");
            }
        }
    }, [hasCEDEAOGarantie, tabId]);

    const loadPaymentModal = (rg) => {
        setReglement(rg);
        reglementWarningWithConfirmAndCancelMessage();
    };

    const printRefContrat = useRef();
    const printRefAttestation = useRef();
    const printReference = useRef();
    const printAttestation = createRef();
    const printedAttestation = useRef();
    const printedCEDEAOAttestation = useRef();
    const printRecu = createRef();

    const handlePrint = useReactToPrint({
        content: () => printReference.current,
        onAfterPrint: () => {
            setPrintingCP(false);
        },
    });

    const handleRecu = useReactToPrint({
        content: () => printRecu.current,
    });

    const exportToPdf = () => {
        setLoadingPrinting(true);
        setPrintingCP(true);
        axiosInstance.get(`/api/contrat/impression/codeId/${contrat?.codeId}/`)
            .then((res) => {
                setContrat(res.data);
                setTimeout(() => {
                    handlePrint();
                    setLoadingPrinting(false);
                }, 100);
            })
            .catch((err) => {
                console.log(err);
                toast("Erreur lors de l'impression du contrat");
            });
    };

    const exportRecuToPdf = () => {
        handleRecu();
    };

    const exportAttestationToPdf = useReactToPrint({
        content: () => printedAttestation.current,
    });

    const exportCEDEAOAttestationToPdf = useReactToPrint({
        content: () => printedCEDEAOAttestation.current,
        onBeforeGetContent: () => setPrintingCEDEAOAttestation(true),
    });

    const reglementWarningWithConfirmAndCancelMessage = () => {
        setModalModePaiement(true);
    };

    const loadModal = (rg) => {
        setReglement(rg);
        setTimeout(() => {
            setModalOpen(true);
        }, 100);
    };

    useEffect(() => {
        if (param.contratId) {
            axiosInstance.get(`/api/contrat/codeId/${param.contratId}`)
                .then((res) => {
                    // console.log(res.data);
                    const reglements = res.data.reglements || [];
                    console.log("Reglements: ", reglements);
                    const hasIncompleteReglement = reglements?.some(r =>
                        !r.modePaiement && !r.dateReglement
                    );
                    console.log("Has incomplete reglement0", hasIncompleteReglement)
                    if (!hasIncompleteReglement) {
                        console.log("Has incomplete reglement");
                        setRegle(true);
                    } else {
                        setRegle(false);
                    }
                    if (!reglements || reglements.length === 0) {
                        setRegle(false);
                    }
                    setContrat(res.data);
                    // Règlements embarqués dans le contrat — utilisés en fallback
                    // quand la recherche par police ne retourne rien (ex. contrats repris
                    // dont numeroPoliceP était null avant la correction du script de reprise).
                    const embeddedReglements = res.data.reglements || [];

                    // Priorité à numeroPoliceM (relie tous les avenants d'une même police,
                    // qu'ils soient repris ou natifs). numeroPoliceP en fallback pour les
                    // contrats PoolIns dont numeroPoliceM n'est pas renseigné.
                    const policeNum = res.data.numeroPoliceM || res.data.numeroPoliceP;
                    axiosInstance.get(`/api/reglement/police/${policeNum}`)
                        .then((resp) => {
                            const regs = resp.data;
                            if (regs && regs.length > 0) {
                                // L'API retourne des règlements : c'est la source autoritaire
                                // (couvre tous les avenants de la même police).
                                const hasIR = regs.some(r =>
                                    !r.modePaiement && !r.dateReglement
                                );
                                setRegle(!hasIR);
                                setReglements(regs);
                            } else {
                                // Fallback : règlements embarqués dans le contrat courant.
                                // Cas typique : contrats repris sans numeroPoliceP, ou police
                                // dont les règlements ne sont pas encore liés par ce champ.
                                setReglements(embeddedReglements);
                            }
                        })
                        .catch((err) => {
                            console.log(err);
                            // En cas d'erreur réseau, on utilise quand même les données embarquées
                            setReglements(embeddedReglements);
                        });

                    axiosInstance.get(`/api/reglement/check-ristourne/${res.data?.souscripteur?.numeroAssureP}`)
                        .then((resp) => {
                            // console.log("Having ristourne: ", resp.data);
                            setHavingRistourne(resp.data);
                        })
                        .catch((err) => {
                            console.log(err);
                        });
                    res.data?.engins && res.data?.engins.forEach((e) => {
                        if (e?.carteGrise) {
                            // console.log(e.carteGrise);
                            fetch(
                                `${API_URL}/api/engin/carte-grise/${e?.carteGrise?.split("/")[1]
                                }`,
                                {
                                    headers: {
                                        Authorization: `Bearer ${TOKEN}`,
                                        "Content-Type": "application/json",
                                        "Access-Control-Allow-Origin": "*",
                                        "Access-Control-Allow-Methods":
                                            "GET, PUT, POST, DELETE, OPTIONS",
                                        "Access-Control-Allow-Headers":
                                            "Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With",
                                    },
                                }
                            )
                                .then(async (response) => {
                                    // console.log("The response", response);

                                    // convert byte to file
                                    const imageBytes = await response.arrayBuffer();
                                    // console.log("images byte: ", imageBytes);
                                    var blob = new Blob([imageBytes], {
                                        type: "application/pdf",
                                    });
                                    // console.log("Blob: ", blob);
                                    var imageUrl = URL.createObjectURL(blob);
                                    // console.log("Image URL: ", imageUrl);
                                    setPdfPreviewUrl(imageUrl);
                                    var file = new File([blob], e.carteGrise.split("//")[2], {
                                        type: "application/pdf",
                                    });
                                    // console.log("File: ", file);
                                })
                                .catch((error) => {
                                    console.log(error);
                                });
                        }
                    });
                    // console.log("Contrat: ", contrat);
                })
                .catch((err) => {
                    console.log(err);
                }).finally(() => {
                    setLoading(false);
                });
        }

        axiosInstance.get(`/api/parametre/type/BANQUE`)
            .then((res) => {
                setBanques(res.data);
            })
            .catch((err) => {
                console.log(err);
            });
    }, [param.contratId, modalAvenantOrdre, modalAvenantOrdreEngin, reload]);

    const attestationPrinting = (engin) => {
        // console.log("update printing");
        // setPrintingAttestation(true);
        // setTimeout(() => {
        //     exportAttestationToPdf();
        //     onTabsChange("1");
        //     setModalAttOpen(false);
        // }, 200);
        axiosInstance.get(`/api/engin/attestation/${engin.codeId}/${numeroAttestation}/CIMA`)
            .then((res) => {
                console.log(res);
                if (res.status === 226) {
                    toast("Ce numéro d'attestation n'existe pas ou est déjà utilisé");
                } else {
                    console.log("Export data");
                    exportAttestationToPdf();
                    onTabsChange("1");
                    setModalAttOpen(false);
                }
                setLoadingPrinting(false);
            })
            .catch((err) => {
                console.log(err);
                setLoadingPrinting(false);
            });
    };

    const attestationDamagedPrinting = (engin) => {
        // console.log("update printing");
        setAttestationDamaged(true);

    };

    const attestationCEDEAODamagedPrinting = (engin) => {
        // console.log("update printing");
        setAttestationDamaged(true);

    };

    const printingDamagedAttestation = (engin) => {
        axiosInstance.get(`/api/engin/attestation/damaged/${engin.codeId}/${numeroAttestation}/SIMPLE`)
            .then((res) => {
                console.log(res);
                if (res.status === 226) {
                    toast("Ce numéro d'attestation n'existe pas ou est déjà utilisé");
                } else {
                    console.log("Export data");
                    exportAttestationToPdf();
                    onTabsChange("1");
                    setModalAttOpen(false);
                }
            })
            .catch((err) => {
                console.log(err);
            });
    }

    const printingDamagedCEDEAOAttestation = (engin) => {
        exportCEDEAOAttestationToPdf();
        axiosInstance.get(`/api/engin/attestation/damaged/${engin.codeId}/${numeroAttestation}/SIMPLE`)
            .then((res) => {
                console.log(res);
                if (res.status === 226) {
                    toast("Ce numéro d'attestation n'existe pas ou est déjà utilisé");
                } else {
                    console.log("Export data");
                    exportAttestationToPdf();
                    onTabsChange("1");
                    setModalAttOpen(false);
                }
            })
            .catch((err) => {
                console.log(err);
            });
    }

    const attestationNonPrintedPrinting = () => {
        // console.log("update printing");
        console.log("Export data");
        exportAttestationToPdf();
        onTabsChange("1");
        setModalAttOpen(false);
    };

    const attestationCEDEAONonPrintedPrinting = () => {
        // console.log("update printing");
        console.log("Export data");
        exportCEDEAOAttestationToPdf();
        onTabsChange("1");
        setModalCEDEAOAttOpen(false);
    };

    const showContractValidationConfirm = () => {
        confirm({
            title: "Etes-vous sûr de vouloir valider ce contrat?",
            icon: <ExclamationCircleFilled />,
            content: "Toutes vos actions sont historisées!",
            okText: "Oui",
            okType: "danger",
            cancelText: "Annuler",
            onOk() {
                console.log("OK");
                validateContrat();
            },
            onCancel() {
                console.log("Cancel");
            },
        });
    };

    const validateContrat = () => {
        // console.log("update validating");
        axiosInstance.get(`/api/contrat/valider/${contrat?.codeId}`)
            .then((res) => {
                console.log(res.data);
                toast("Contrat validé avec succès");
                navigate(`/details-contrat/${res.data.codeId}`, { replace: true });
                window.location.reload();
            })
            .catch((err) => {
                console.log(err);
                toast("Erreur lors de la validation du contrat");
            });
    };

    const attestationCEDEAOPrinting = (engin) => {
        setPrintingCEDEAOAttestation(true);
        setTimeout(() => {
            exportCEDEAOAttestationToPdf();
        }, [500]);
        axiosInstance.get(`/api/engin/attestation/${engin.codeId}/${numeroAttestation}/CEDEAO`)
            .then((res) => {
                console.log(res);
                if (res.status === 226) {
                    toast("Ce numéro d'attestation n'existe pas ou est déjà utilisé");
                } else {
                    console.log("Export data");
                    exportAttestationToPdf();
                    onTabsChange("1");
                    setModalAttOpen(false);
                }
            })
            .catch((err) => {
                console.log(err);
                exportAttestationToPdf();
            });
    };

    const exportToOnePdf = () => {
        setLoadingPrinting(true);
        setTimeout(() => {
            //      handlePrint();
            handleExport();
        }, [500]);
    };

    const handleExport = async () => {
        setLoadingPrinting(true);
        try {
            const formData = new FormData();
            const pdfDoc = await PDFDocument.create();
            const attPdfDoc = await PDFDocument.create();
            const pageWidth = 1239, pageHeight = 1754;

            const refContrat = printRefContrat.current;
            const refAttestation = printRefAttestation.current;

            const processPdf = async (ref, doc, width, height) => {
                if (!ref) return;
                const canvas = await html2canvas(ref, { scale: 2, useCORS: true, backgroundColor: null });
                const imgBytes = await fetch(canvas.toDataURL('image/png')).then(res => res.arrayBuffer());
                const pdfImage = await doc.embedPng(imgBytes);
                const page = doc.addPage([width, height]);
                page.drawImage(pdfImage, { x: 0, y: 0, width, height });
            };

            await Promise.all([
                processPdf(refContrat, pdfDoc, pageWidth, pageHeight),
                processPdf(refAttestation, attPdfDoc, pageHeight, pageWidth)
            ]);

            // Save PDFs and create Blob
            const [pdfBytes, attPdfBytes] = await Promise.all([pdfDoc.save(), attPdfDoc.save()]);

            formData.append("cp", new File([new Blob([pdfBytes], { type: 'application/pdf' })], `condition_particuliere.pdf`));
            formData.append("att", new File([new Blob([attPdfBytes], { type: 'application/pdf' })], `attestation.pdf`));
            formData.append("contrat", contrat?.codeId);

            const response = await axiosMultiPartDataInstance.post('/api/contrat/impression', formData, {
                responseType: 'blob',
                headers: { 'Content-Type': 'multipart/form-data' }
            });
            if (response.status === 200) {
                toast("Documents envoyés avec succès!");
                console.log("PDF generated successfully!", response);
            } else {
                toast("Erreur lors de l'envoi du document!");
                console.error("Error:", response);
            }
            console.log("PDF generated successfully!", response);
        } catch (error) {
            toast("Erreur lors de l'impression");
            console.error("Error:", error);
        } finally {
            setLoadingPrinting(false);
            setContratModal(false);
        }
    };

    const duplicata = () => {
        // console.log(numeroPaiement);
        confirm({
            title: "Etes-vous sûr de vouloir faire un duplicata?",
            icon: <ExclamationCircleFilled />,
            content: "Toutes vos actions sont historisées!",
            okText: "Oui, effectuer",
            okType: "danger",
            cancelText: "Annuler",
            onOk() {
                console.log("OK");
                avenantDuplicata();
            },
            onCancel() {
                console.log("Cancel");
            },
        });
    };

    const avenantDuplicata = () => {
        toast("En cours de traitement...");
        axiosInstance.get(`/api/contrat/duplicata/${param.contratId}`)
            .then(res => {
                console.log("res.data ", res.data);
                navigate(`/details-contrat/${res.data.codeId}`, { replace: true });
                toast("Duplicata effectué avec succès!");
            }).catch(err => {
                console.log("err: ", err);
                toast("Erreur lors de l'envoi du duplicata!");
            });
    }


    return (
        <div class="layout-wrapper layout-content-navbar  ">
            <div class="layout-container">
                <SideBar currentMenu={"PRODUCTION"} />

                {/* <!-- Layout container --> */}
                <div class="layout-page">
                    <NavBar />

                    {/* <!-- Content wrapper --> */}
                    <div class="content-wrapper">
                        {/* <!-- Content --> */}
                        <div class="container-xxl flex-grow-1 container-p-y">

                            <div style={{
                                minHeight: '100vh',
                                background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
                                padding: '0'
                            }}>
                                {/* Header Section */}
                                <div style={{
                                    background: 'linear-gradient(135deg, #242166 0%, #1e40af 100%)',
                                    padding: '12px 24px',
                                    boxShadow: '0 10px 40px rgba(36, 33, 102, 0.3)',
                                    marginBottom: '24px'
                                }}>
                                    <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
                                        <Row justify="space-between" align="middle" gutter={[16, 16]}>
                                            <Col xs={24} md={12}>
                                                <Space direction="vertical" size={4}>
                                                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                                        <FileTextOutlined style={{ fontSize: '28px', color: '#93c5fd' }} />
                                                        <h1 style={{
                                                            color: '#ffffff',
                                                            fontSize: '28px',
                                                            fontWeight: '700',
                                                            margin: 0
                                                        }}>
                                                            Contrat N° {contrat?.numeroAvenant ? contrat?.numeroAvenant : contrat?.numeroPoliceP ? contrat?.numeroPoliceP : contrat?.numeroPoliceM}
                                                        </h1>
                                                    </div>
                                                    <p style={{
                                                        color: '#93c5fd',
                                                        fontSize: '14px',
                                                        margin: 0,
                                                        marginLeft: '40px'
                                                    }}>
                                                        Détails et gestion du contrat d'assurance
                                                    </p>
                                                </Space>
                                            </Col>
                                            <Col xs={24} md={12} style={{ textAlign: 'right' }}>
                                                <Space size={12} wrap>
                                                    {contrat?.commentaire?.startsWith('[REPRISE:') && (() => {
                                                        const source = contrat.commentaire.match(/\[REPRISE:([^\]]+)\]/)?.[1] || '';
                                                        return (
                                                            <Tag
                                                                style={{
                                                                    background: 'rgba(250,173,20,0.2)',
                                                                    border: '1px solid #faad14',
                                                                    color: '#faad14',
                                                                    borderRadius: '8px',
                                                                    padding: '4px 12px',
                                                                    fontSize: '12px',
                                                                    fontWeight: '700',
                                                                    letterSpacing: '0.5px',
                                                                }}
                                                            >
                                                                📥 REPRISE {source}
                                                            </Tag>
                                                        );
                                                    })()}
                                                    <Card
                                                        size="small"
                                                        style={{
                                                            background: 'rgba(255, 255, 255, 0.15)',
                                                            backdropFilter: 'blur(10px)',
                                                            border: '1px solid rgba(255, 255, 255, 0.2)',
                                                            borderRadius: '12px'
                                                        }}
                                                        bodyStyle={{ padding: '12px 16px' }}
                                                    >
                                                        <Space direction="horizontal" size={2}>
                                                            <div style={{ color: '#93c5fd', fontSize: '11px' }}>Statut : </div>
                                                            <Tag
                                                                color={getStatusColor(contrat?.statutContrat)}
                                                                style={{
                                                                    margin: 0,
                                                                    borderRadius: '8px',
                                                                    padding: '4px 12px',
                                                                    fontSize: '13px',
                                                                    fontWeight: '600'
                                                                }}
                                                            >
                                                                {getStatusText(contrat?.statutContrat)}
                                                            </Tag>
                                                        </Space>
                                                    </Card>
                                                </Space>
                                            </Col>
                                        </Row>
                                    </div>
                                </div>

                                <div style={{ maxWidth: '1400px', margin: '0 auto', padding: '0 24px 40px' }}>
                                    {/* Main Content Tabs */}
                                    <Card
                                        style={{
                                            borderRadius: '16px',
                                            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
                                            border: '1px solid #e5e7eb',
                                            overflow: 'hidden'
                                        }}
                                        bodyStyle={{ padding: 0 }}
                                    >
                                        <Tabs
                                            activeKey={activeTab}
                                            onChange={setActiveTab}
                                            size="large"
                                            centered
                                            style={{ margin: 0 }}
                                            tabBarStyle={{
                                                padding: '0 24px',
                                                margin: 0,
                                                background: 'linear-gradient(to bottom, #ffffff, #f9fafb)',
                                                borderBottom: '2px solid #e5e7eb'
                                            }}
                                        >
                                            <TabPane
                                                tab={
                                                    <span style={{ fontSize: '15px', fontWeight: '600' }}>
                                                        <FileTextOutlined style={{ marginRight: '8px' }} />
                                                        Détails
                                                    </span>
                                                }
                                                key="details"
                                            >
                                                {/* <div style={{ padding: '32px 24px' }}> */}
                                                <DetailsTab
                                                    contrat={contrat}
                                                    reglements={reglements}
                                                    contratModal={contratModal}
                                                    setContratModal={setContratModal}
                                                    exportToPdf={exportToPdf}
                                                    duplicata={duplicata}
                                                    loadingPrinting={loadingPrinting}
                                                    printingCP={printingCP}
                                                    exportToOnePdf={exportToOnePdf}
                                                    printingAttestation={printingAttestation}
                                                    printingCEDEAOAttestation={printingCEDEAOAttestation}
                                                    printedAttestation={printedAttestation}
                                                    printedCEDEAOAttestation={printedCEDEAOAttestation}
                                                    printReference={printReference}
                                                    printRefContrat={printRefContrat}
                                                    printRefAttestation={printRefAttestation}
                                                    numeroAttestation={numeroAttestation}
                                                    printingDamagedAttestation={printingDamagedAttestation}
                                                    attestationDamaged={attestationDamaged}
                                                    setAttestationDamaged={setAttestationDamaged}
                                                    setPrintingAttestation={setPrintingAttestation}
                                                    printingDamagedCEDEAOAttestation={printingDamagedCEDEAOAttestation}
                                                    setPrintingCEDEAOAttestation={setPrintingCEDEAOAttestation}
                                                    attestationCEDEAOPrinting={attestationCEDEAOPrinting}
                                                    attestationCEDEAODamagedPrinting={attestationCEDEAODamagedPrinting}
                                                    pdfPreviewUrl={pdfPreviewUrl}
                                                    setPdfPreviewUrl={setPdfPreviewUrl}
                                                    setNumeroAttestation={setNumeroAttestation}
                                                    rightsService={rightsService}
                                                    navigate={navigate}
                                                    showContractValidationConfirm={showContractValidationConfirm}
                                                    regle={regle}
                                                    modalAttOpen={modalAttOpen}
                                                    setModalAttOpen={setModalAttOpen}
                                                    modalCEDEAOAttOpen={modalCEDEAOAttOpen}
                                                    setModalCEDEAOAttOpen={setModalCEDEAOAttOpen}
                                                    onTabsChange={onTabsChange}
                                                    tabId={tabId}
                                                    attestationPrinting={attestationPrinting}
                                                    showAttestationCEDEAO={hasCEDEAOGarantie}
                                                />
                                                {/* </div> */}
                                            </TabPane>

                                            <TabPane
                                                tab={
                                                    <span style={{ fontSize: '15px', fontWeight: '600' }}>
                                                        <EditOutlined style={{ marginRight: '8px' }} />
                                                        Avenants
                                                    </span>
                                                }
                                                key="avenants"
                                            >
                                                <div style={{ padding: '12px 24px' }}>

                                                    <AvenantsTab
                                                        contrat={contrat}
                                                        modalAugmentation={modalAugmentation}
                                                        updateAugmentationModal={setModalAugmentation}
                                                        modalDiminution={modalDiminution}
                                                        updateDiminutionModal={setModalDiminution}
                                                        modalProrogation={modalProrogation}
                                                        updateProrogationModal={setModalProrogation}
                                                        modalSuspension={modalSuspension}
                                                        updateSuspensionModal={setModalSuspension}
                                                        modalRemiseEnVigueur={modalRemiseEnVigueur}
                                                        updateRemiseEnVigueurModal={setModalRemiseEnVigueur}
                                                        modalReportEffet={modalReportEffet}
                                                        updateReportEffetModal={setModalReportEffet}
                                                        modalTransfertGarantie={modalTransfertGarantie}
                                                        updateTransfertGarantieModal={setModalTransfertGarantie}
                                                        modalChangementVehicule={modalChangementVehicule}
                                                        updateChangementVehiculeModal={setModalChangementVehicule}
                                                        modalRenouvellement={modalRenouvellement}
                                                        updateRenouvellementModal={setModalRenouvellement}
                                                        modalAvenantOrdre={modalAvenantOrdre}
                                                        updateAvenantOrdreModal={setModalAvenantOrdre}
                                                        modalAvenantOrdreEngin={modalAvenantOrdreEngin}
                                                        updateAvenantOrdreEnginModal={setModalAvenantOrdreEngin}
                                                        modalIncorporation={modalIncorporation}
                                                        updateIncorporationModal={setModalIncorporation}
                                                        modalRetrait={modalRetrait}
                                                        updateRetraitModal={setModalRetrait}
                                                        modalDuplicata={modalDuplicata}
                                                        updateDuplicataModal={setModalDuplicata}
                                                        modalResiliation={modalResiliation}
                                                        updateResiliationModal={setModalResiliation}
                                                    />
                                                </div>
                                            </TabPane>
                                        </Tabs>
                                    </Card>
                                </div>
                            </div>
                        </div>

                        {/* <!-- / Content --> */}

                        {/* <!-- Footer --> */}
                        <Footer />
                        {/* <!-- / Footer --> */}

                        <div class="content-backdrop fade"></div>
                    </div>
                    {/* <!-- Content wrapper --> */}
                </div>
                {/* <!-- / Layout page --> */}
            </div>

            {/* <!-- Overlay --> */}
            <div class="layout-overlay layout-menu-toggle"></div>

            {/* <!-- Drag Target Area To SlideIn Menu On Small Screens --> */}
            <div class="drag-target"></div>
        </div>
    );
};

export default DetailsContrat;
